export const isPromiseFulfilled = <T>(
  x: PromiseSettledResult<T>
): x is PromiseFulfilledResult<T> => x.status === 'fulfilled';

export const isPromiseFailed = <T>(
  x: PromiseSettledResult<T>
): x is PromiseRejectedResult => x.status === 'rejected';

export const isDefined = <T>(x: T | undefined | null): x is T =>
  x !== undefined && x !== null;

type ObjectToEncode = Record<
  string,
  string | number | boolean | null | undefined
>;
export const encodeObject = <T extends ObjectToEncode>(obj: T): string => {
  const nonNilEntries = Object.entries(obj).filter(([, v]) => isDefined(v)) as [
    string,
    NonNullable<T[keyof T]>,
  ][];

  return nonNilEntries
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
};

export const encodeObjectForQuery = <T extends ObjectToEncode>(
  obj: T
): string => {
  const result = encodeObject(obj);

  return result ? `?${result}` : '';
};
